// extracted by mini-css-extract-plugin
export default {"redBorder":"paperMatrixQues_redBorder__4eAwt","greenBorder":"paperMatrixQues_greenBorder__UN6Kq"};